import {
  FufillmentOrderItem,
  Fulfillment,
  Medication,
  OrderViewPortal,
} from '../../../__generated__/graphql';
import { Alert, FormControl, Button, Popover, Select, VStack, Input } from 'native-base';
import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { graphql } from '../../../__generated__';
import currency from 'currency.js';
import { orderQuery } from '../../hooks/useOrder';

export const SwapItemModal = ({
  order,
  close,
  item,
  medication,
}: {
  medication: Medication;
  order: Fulfillment;
  close: () => void;
  item: FufillmentOrderItem;
}) => {
  const { data, loading } = useQuery(
    graphql(`
      query productsPortalSwap($id: String) {
        customersMenu(customerId: $id) {
          prescription {
            repeatsAvailable
            dispensedDate
            createdAt
            qty
            instructions
            doctor
            id
          }
          medication {
            id
            name
            image
            retail
          }
          message
          status
        }
      }
    `),
    { variables: { id: order.customer?.id } },
  );

  const [swapMutation, { loading: swapping }] = useMutation(
    graphql(`
      mutation swapOrderItem(
        $order: ID
        $oldItem: String
        $oldItemPrescription: String
        $newItem: String
        $newItemPrescription: String
        $reason: String
      ) {
        updateOrderItem(
          order: $order
          oldItem: $oldItem
          oldItemPrescription: $oldItemPrescription
          newItem: $newItem
          newItemPrescription: $newItemPrescription
          reason: $reason
        ) {
          id
        }
      }
    `),
    {
      refetchQueries: [
        {
          query: orderQuery,
          fetchPolicy: 'network-only',
          variables: {
            ID: order.id,
          },
        },
      ],
    },
  );

  const availableProducts = (data?.customersMenu as OrderViewPortal[])?.filter(
    (a) => a?.status === 'AvailableScript' && a?.medication?.id !== item?.ID,
  );

  const [selectedNewItem, setSelectedNewItem] = useState('');
  const [reason, setReason] = useState('');

  const canSubmit = reason.length > 2 && selectedNewItem?.length > 2;

  const clickedSwap = async () => {
    const matchingNewItem = availableProducts?.find((a) => a?.medication?.id === selectedNewItem);

    if (
      !matchingNewItem ||
      !matchingNewItem?.medication?.id ||
      !matchingNewItem?.prescription?.id
    ) {
      return;
    }
    await swapMutation({
      variables: {
        order: order?.id,
        oldItem: item?.ID,
        oldItemPrescription: item.PrescriptionID,
        reason,
        newItem: matchingNewItem.medication.id,
        newItemPrescription: matchingNewItem.prescription.id,
      },
    });

    close();
  };

  return (
    <Popover.Content bg={'white'}>
      <Popover.Arrow />
      <Popover.CloseButton />
      <Popover.Header>
        {`Swap ${medication?.name} ${currency(medication?.retail ?? 0).format()}`}
      </Popover.Header>
      <Popover.Body bg={'white'}>
        <VStack space={2}>
          <Alert>The customer will not be charged the difference</Alert>

          <FormControl>
            <FormControl.Label>Available Scripts</FormControl.Label>

            <Select
              selectedValue={selectedNewItem}
              onValueChange={(e) => setSelectedNewItem(e)}
              isDisabled={loading || swapping}
            >
              {availableProducts?.map((a) => (
                <Select.Item
                  label={`${a.medication?.name} ${currency(a?.medication?.retail ?? 0).format()}`}
                  value={a?.medication?.id ?? ''}
                />
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormControl.Label>Reason</FormControl.Label>

            <Input value={reason} onChangeText={(e) => setReason(e)} isDisabled={swapping} />
          </FormControl>

          <Button disabled={!canSubmit} size={'sm'} isLoading={swapping} onPress={clickedSwap}>
            Swap
          </Button>
        </VStack>
      </Popover.Body>
    </Popover.Content>
  );
};
